// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'whatwg-fetch';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueAnalytics from 'vue-analytics';
import MobileDetect from './core/mobile-detect';
import branch from './pages/branch';
import building from './pages/building';
import MainPageBuilding from './pages/building/mainpage/index';
import home from './pages/home';
import transaction from './pages/transaction';
import MainPageTransaction from './pages/transaction/mainpage/index';
import stock from './pages/stock';
import stockDetail from './pages/stockDetail';
import recuritment from './pages/recuritment';
import recruitmentPost from './pages/recruitmentPost';
import projectOffice from './pages/project/office';
import priceChart from './pages/priceChart';
import article from './pages/article';
import recommend from './pages/recommend';
import minisite from './pages/minisite';
import calculator from './pages/calculator';
import record from './pages/record';
import agent from './pages/agent';
import researchChart from './pages/researchChart';
import openday from './pages/openday';
import firsthandBuilding from './pages/firsthandBuilding';
import media from './pages/media';
import mitaclub from './pages/mitaclub';

Vue.config.productionTip = true;

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: '',
  messages: {
    zh: { },
    en: { },
  },
});

const isProd = process.env.NODE_ENV === 'production';

Vue.use(MobileDetect);
Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS_TRACKING_ID || 'UA-1234-5',
  debug: {
    enabled: !isProd,
    sendHitTask: isProd,
  },
});

/* eslint-disable no-new */
if (document.getElementById('home')) {
  home(i18n);
}

if (document.getElementById('transaction')) {
  transaction(i18n);
}

if (document.getElementById('mainpage-transaction')) {
  MainPageTransaction(i18n);
}

if (document.getElementById('mainpage-building')) {
  MainPageBuilding(i18n);
}

if (document.getElementById('project-office')) {
  projectOffice(i18n);
}

if (document.getElementById('recuritment')) {
  recuritment(i18n);
}

if (document.getElementById('recruitment-post')) {
  recruitmentPost(i18n);
}

if (document.getElementById('branch')) {
  branch(i18n);
}

if (document.getElementById('building')) {
  building(i18n);
}

if (document.getElementById('stock')) {
  stock(i18n);
}

if (document.getElementById('stock-detail')) {
  stockDetail(i18n);
}

if (document.getElementById('price-chart')) {
  priceChart(i18n);
}

if (document.getElementById('article')) {
  article(i18n);
}

if (document.getElementById('recommend')) {
  recommend(i18n);
}

if (document.getElementById('minisite')) {
  minisite(i18n);
}

if (document.getElementById('calculator')) {
  calculator(i18n);
}

if (document.getElementById('record')) {
  record(i18n);
}

if (document.getElementById('agent')) {
  agent(i18n);
}

if (document.getElementById('combine-chart')) {
  researchChart(i18n);
}

if (document.getElementById('openday')) {
  openday(i18n);
}

if (document.getElementById('firsthand-building')) {
  firsthandBuilding(i18n);
}

if (document.getElementById('media')) {
  media(i18n);
}

if (document.getElementById('mitaclub')) {
  mitaclub(i18n);
}
